export const colors = {
  PRIMARY: "#173AEB",
  PRIMARY_LIGHT: "#76B9F0",
  PRIMARY_DARK: "#061BB0",
  SECONDARY: "#FC9642",
  LIGHT: "#F3F7FA",
  LIGHT_GREY: "#9E9E9E",
  GREY: "#6C6C6C",
  BLACK: "#2C2C2C",
  WHITE: "#FFFFFF",
  ERROR: "#FF0000",
};
